import 'lazysizes';

import './base/index.js';
import './nav';
import './utility';
import './select';
import './video';
import './radio-hover';
import { accordion } from './accordion';
import './product_gallery';
import './product_colors';
import './product_fixed_cart';
import './popups';
import './parallax';
import './scroll-top';
import './infinite-scroll';
import './search';
import './variants';
import './ajax-cart';
import './notification-bar';
import './newsletter-modal';
import { labelFade } from './labels';
import './account-login-register';
import './account-side-toggle';
import './article-imges';
import { mailchimp } from './mailchimp';
import { setCookie, getCookie } from './cookie';
import './equalize-height';
import { cartVariants, cartVariantsUpdate } from './cart-variants';
import './wishlist';
import './customr';
import './look-article';
import './filters';
import './lookbook-slider';
import './animate';
import { changeImage } from './change-image';
import { selectJs } from './select';
import { tabs } from './tabs';

import { initMap } from './map/init';
import { deepLevelClass } from './nav-level-class';
import './map/stores-form';

accordion('.product__details .accordion h5', false);
accordion('.accordion h3', true);

labelFade('.field, .textarea');
changeImage('.intro');
changeImage('.collections .collections__image');
changeImage('.overlay--brand .mobile-only');
changeImage('.two-columns .two-columns__image');
changeImage('.image-text .image__box');

mailchimp('.newsletter-modal form', function(data) {
  const $newsletterModal = $('.newsletter-modal');
  $newsletterModal.find('.step-1').hide();
  $newsletterModal.find('.step-2').show();
  setCookie('newsletterModal', 'true', 999);
});

mailchimp('#footer-newsletter form');
cartVariantsUpdate();

if ($('.map').length && mapMarkers.length) {
  initMap('.map', mapMarkers);
}

deepLevelClass('.store-locations');

$('.table--cart')
  .find('.variant-select')
  .each(function() {
    const $this = $(this);
    const currentId = $this.data('current-id');
    cartVariants(line_items[currentId], $this.attr('id'));
  });

selectJs('.single-option-selector')
selectJs('.select-wrapper select');
selectJs('.field-select select');

tabs('.look-nav li a', '.look-tabs');

// PLP: Detect touch device and switch to exposed product info & collection text/link if it's a touch device.
function is_touch_device() {
  var prefixes = ' -webkit- -moz- -o- -ms- '.split(' ');
  var mq = function(query) {
    return window.matchMedia(query).matches;
  }

  if (('ontouchstart' in window) || window.DocumentTouch && document instanceof DocumentTouch) {
    return true;
  }

  // include the 'heartz' as a way to have a non matching MQ to help terminate the join
  // https://git.io/vznFH
  var query = ['(', prefixes.join('touch-enabled),('), 'heartz', ')'].join('');
  return mq(query);
}

if(is_touch_device()) {
  $('.collection__listing .product-box').addClass('product-touch__device');
}



// WEBPACK FOOTER //
// ../assets/js/main.js